/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react'
import { notifyError } from 'utils'
import { Panel, Tooltip, Whisper } from 'rsuite'
import './CardTable.scss'
import { Button } from 'shared/atoms'
import { Status } from '../../../pages/documentVerification/types'
import DefaultDocumentIcon from '../../../assets/images/default-document-image.jpg'
import PdfIcon from '../../../assets/images/pdf-icon.svg'

interface VerifyDocumentCardProps extends React.ComponentProps<typeof Panel> {
  title?: string;
  imageUrl: string;
  subtitle?: string;
  data?: any;
  code?: string;
  number?: string;
  handleSelection?: (data?: any) => void;
  handleCardClick?: (data?: any) => void;
  handleVerifyDoc?: (documentId: number) => void;
  onReject?: (data?: any) => void;
}

const VerifyDocumentCard: React.FC<VerifyDocumentCardProps> = ({
  title = 'Document Name',
  imageUrl,
  subtitle,
  code,
  number = 'VT-PAN-3456',
  handleSelection,
  handleVerifyDoc,
  handleCardClick,
  onReject,
  data
}) => {
  const [imgSrc, setImgSrc] = useState(imageUrl)

  const handleImageError = () => {
    setImgSrc(DefaultDocumentIcon)
  }

  const handleRejectClick = () => {
    onReject?.(data)
  }

  const handleVerifyClick = async () => {
    if (!data?.id) return

    try {
      handleVerifyDoc?.(data.id)
    } catch (error) {
      notifyError('Verification failed')
    }
  }
  const isPdf = imageUrl?.toLowerCase().endsWith('.pdf')

  const onCardClick = () => {
    if (!isPdf && handleCardClick) {
      handleCardClick(data)
    }
  }
  const handleViewPdf = () => {
    if (isPdf) {
      window.open(imageUrl, '_blank', 'noopener,noreferrer')
    }
  }
  const handleDocumentRender = () => {
    if (isPdf) {
      return (
        <div
          className="pdf-icon-wrapper"
          onClick={handleViewPdf}
          role="button"
          tabIndex={0}
          aria-label="View PDF"
        >
          <Whisper
            placement="bottom"
            trigger="hover"
            speaker={<Tooltip>View Document</Tooltip>}
          >
            <img
              className="new-doc-image doc-pdf-icon"
              src={PdfIcon}
              alt={subtitle}
              onError={handleImageError}
            />
          </Whisper>
        </div>
      )
    }
    return (
      <Whisper
        placement="bottom"
        trigger="hover"
        speaker={<Tooltip>View Document</Tooltip>}
      >
        <img
          className="new-doc-image"
          src={imgSrc}
          alt={subtitle}
          onError={handleImageError}
        />
      </Whisper>
    )
  }
  const status = data?.docStatus ?? data?.status
  let statusClass = 'pending'
  if (status === Status.Accepted) {
    statusClass = 'accepted'
  } else if (status === Status.Rejected) {
    statusClass = 'rejected'
  } else {
    statusClass = 'pending'
  }

  return (
    <div
      onClick={() => handleSelection?.(data)}
      className={`doc-card document-card new-docCard ${statusClass}`}
    >
      <div className="card-main-container">
        <div className="card-details-container">
          <div className="doc-card-header">
            <h3>{title}</h3>
          </div>
          <div className="doc-card-number">
            <h3>{number}</h3>
          </div>
          {code && (
            <div className="doc-card-number">
              <h3>{code}</h3>
            </div>
          )}
        </div>
        <div className="new-card-header" onClick={onCardClick}>
          {handleDocumentRender()}
        </div>
      </div>
      <div className="button-group">
        <Button
          className="reject-button"
          onClick={handleRejectClick}
          disabled={status === 'Rejected'}
        >
          {status === 'Rejected' ? 'Rejected' : 'Reject'}
        </Button>
        <Button
          appearance="primary"
          className="accept-button"
          onClick={handleVerifyClick}
          disabled={status === 'Accepted'}
        >
          {status === 'Accepted' ? 'Verified' : 'Verify'}
        </Button>
      </div>
    </div>
  )
}

export default VerifyDocumentCard
